require('es6-promise').polyfill();
import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import NewsletterRegister from './shared/Tools/NewsletterRegister';
import moment from 'moment';

class Home extends React.Component {

  constructor(props) {
		super(props);
	}

	componentDidMount() {
		console.log('Home: componentDidMount');
	}

	render() {

		// console.log('***** DEBUG ZONE *****');
		return (
			<div className="animated fadeIn row-margin-bottom-200">

				<div className="row">
				<div className="col-12 home-header-margin text-center">
					<h1>STATELO</h1>
				  <h4>Votre plateforme de statistiques</h4>
				</div>
				</div>

				<div className="row row-margin-bottom-50">

					<div className="col-md-6 col-xs-12 home-module-margin text-center">
						<a href="/tableau-de-bord">
			  			<img className="img-fluid" src="/img/regulier-aut-2019.png" alt="promo-aut-2019" width="400"/>
						</a>
					</div>

					<div className="col-md-6 col-xs-12 home-module-margin text-center">
						<Link to="/qvnea/mont-qvnea">
							<img className="img-fluid" src="/img/mq-logo-2023.png" alt="mont-qvnea" width="465"/>
						</Link>
					</div>

					<div className="col-md-6 col-xs-12 home-module-margin text-center">
						<a href="http://devaxia.com" target="_blank">
							<img className="img-fluid" src="/img/devaxia_pub02_300b.png" alt="devaxia" width="400"/>
						</a>
					</div>

					<div className="col-md-6 col-xs-12 home-module-margin text-center">
						<a href="http://facebook.com/StateloStats" target="_blank">
			  			<img className="img-fluid" src="/img/suivez-facebook-01b.png" alt="suivez-nous" width="400"/>
						</a>
					</div>

				</div>

				<div className="div-privacypolicy">
					{/*<i className="icon-trophy"></i> Politique de confidentialité*/}
					{/*<span>Politique de confidentialité</span>*/}
					<Link to='/confidentialite'>
						Politique de confidentialité
					</Link>
				</div>

      </div>
		);
	}

}

export default Home;